/* eslint-disable no-unused-vars */
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material"
import { Box } from "@mui/system"
import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { getDataUserOrganizationID, getOrganizationCommercialUserType } from "../../../../../redux/actions/Organizations"

import { namesTypesTraduc } from "../../../../../utils/traducTypes"
import useStyleUserSuscriberSeeMore from "./useStyleUserSuscriberSeeMore"
import CloseIcon from "@mui/icons-material/Close"
import { getLoginAccountStatusCorpEntities } from "../../../../../app/services/LoginAccount/getLoginAccountStatus"
import {
  getAllTypesUser,
  updateUserOrganization,
  updateUserStatusLoginAccount,
} from "../../../../../redux/actions/User"
import { getUserStatusCorpEntities } from "../../../../../app/services/Organization/getUserStatusCorpEntities"
import { helpGetUserLoginAccountWithEmail } from "../../../../../app/services/LoginAccount/helpGetUserLoginAccountWhitEmail"
import ModalConfirmChange from "../../../Organizations/User/ModalConfirmChange/ModalConfirmChange"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import CancelIcon from "@mui/icons-material/Cancel"
import HourglassTopOutlinedIcon from "@mui/icons-material/HourglassTopOutlined"
import { getTraducTypeUser } from "../../../../../utils/UserTools"

export const UserSuscriberSeeMore = ({
  item,
  setLoading,
  setstateSeeMore,
  setRows,
}) => {
  const dispatch = useDispatch()
  const [userData, setuserData] = useState(null)
  const classes = useStyleUserSuscriberSeeMore()
  const [selectedStatus, setSelectedStatus] = useState(
    userData?.state?.userStatusCode ?? "",
  )
  const [selectedStatusLoginAccount, setSelectedStatusLoginAccount] = useState(
    userData?.accountStatus?.accountStatusCode ?? "",
  )

  const [selectedType, setSelectedType] = useState(
    userData?.type?.organizationUserTypeCode ?? "",
  )
  const [statesUser, setStatesUser] = useState([])
  const [statesUserOrg, setStatesUserOrg] = useState([])
  const [typesUser, settypesUser] = useState([])
  const [isModalOpenTypeUser, setisModalOpenTypeUser] = useState(false)
  const [isModalOpenStatusAccount, setisModalOpenStatusAccount] =
    useState(false)
  const [isModalOpenStatusUserOrg, setisModalOpenStatusUserOrg] =
    useState(false)
  const currentUserTypeCode = userData?.type?.organizationUserTypeCode || ""
  const currentUserOrgStatusCode = userData?.status?.userStatusCode || ""
  const currentUserStatusCode = userData?.accountStatus?.accountStatusCode || ""
  const currentUserTypeComercialCode = userData?.commercialType?.organizationCommercialUserTypeCode || ""

  const [typeComercial, setTypeComercial] = useState(
    userData?.commercialType?.organizationCommercialUserTypeCode ?? "",
  )
  const [typesComercial, setTypesComercial] = useState([])

  const [isModalOpenTypeComercialUserOrg, setIsModalOpenTypeComercialUserOrg] =
    useState(false)

  const handleChangeTypeComercial = (event) => {
    setTypeComercial(event.target.value)
    setIsModalOpenTypeComercialUserOrg(true)
  }

  const handleChangeTypeComercialUser = async () => {
    const status = await dispatch(
      updateUserOrganization({
        organizationUserId: userData.userId,
        organizationCommercialUserTypeCode: typeComercial,
      }),
    )

    if (status) {
      const refreshTypeComercial = typesComercial.find((item) => item.organizationCommercialUserTypeCode === typeComercial)
      const commercialType = {
        organizationCommercialUserTypeCode: refreshTypeComercial.organizationCommercialUserTypeCode,
        organizationCommercialUserTypeName: refreshTypeComercial.organizationCommercialUserTypeName,
      }
      setuserData({
        ...userData,
        commercialType,
      })
    }
  }
  const getUserStatus = async () => {
    try {
      const status = await getLoginAccountStatusCorpEntities()
      setStatesUser(status.data?.data)
    } catch (error) {
      console.log(error)
    }
  }
  const getAllTypes = async () => {
    try {
      const types = await dispatch(getAllTypesUser())

      settypesUser(types)
    } catch (error) {
      console.log(error)
    }
  }

  const getUserOrgStatus = async () => {
    try {
      const status = await getUserStatusCorpEntities()
      setStatesUserOrg(status.data?.data)
    } catch (error) {
      console.log(error)
    }
  }

  const getUserStatusLoginAccount = async (email, data) => {
    try {
      const status = await helpGetUserLoginAccountWithEmail(email)
      setuserData({
        ...data,
        accountStatus: status?.data?.loginAccount?.accountStatus,
      })
      console.log(data)
    } catch (error) {
      console.log(error)
    }
  }

  const updateUserStatusLoginAcc = async () => {
    const newStatus = await dispatch(
      updateUserStatusLoginAccount({
        loginAccountId: userData.loginAccountId,
        accountStatusCode: selectedStatusLoginAccount,
      }),
    )

    if (newStatus?.accountStatus) {
      const { accountStatusCode, accountStatusDesc } = newStatus.accountStatus

      const accountStatus = {
        accountStatusCode,
        accountStatusDesc,
      }
      setuserData({
        ...userData,
        accountStatus,
      })
    }
  }

  const handleChangeTypeUser = async () => {
    const status = await dispatch(
      updateUserOrganization({
        organizationUserId: userData.userId,
        organizationUserTypeCode: selectedType,
      }),
    )

    if (Number(status?.organizationUserTypeId)) {
      const getByStatusId = typesUser.find(
        (option) =>
          option.organizationUserTypeId ===
          Number(status.organizationUserTypeId),
      )
      const type = {
        organizationUserTypeCode: getByStatusId.organizationUserTypeCode,
        organizationUserTypeName: getByStatusId.organizationUserTypeName,
      }
      setuserData({
        ...userData,
        type,
      })
    }
  }

  const handleChangeStatusUser = async () => {
    const updateStatus = await dispatch(
      updateUserOrganization({
        organizationUserId: userData.userId,
        userStatusCode: selectedStatus,
      }),
    )

    if (Number(updateStatus?.userStatusId)) {
      const getByStatusId = statesUserOrg.find(
        (option) => option.userStatusId === Number(updateStatus.userStatusId),
      )
      const status = {
        userStatusCode: getByStatusId.userStatusCode,
        userStatusName: getByStatusId.userStatusName,
      }
      setuserData({
        ...userData,
        status,
      })
    }
  }

  const codeStatesEnabled = ["ACTIVE", "DELETED", "WAITING_VALIDATION"]
  const codeTypesEnabled = ["ORG-STAFF", "ORG-ADMIN"]
  const codeStatesAccountEnabled = ["ACTIVE"]

  // const filteredTypesOptions = typesUser.filter((option) =>
  //   codeTypesEnabled.includes(option.organizationUserTypeCode),
  // )

  // const filteredUserStatus = statesUser.filter((option) =>
  //   codeStatesAccountEnabled.includes(option.accountStatusCode),
  // )
  // const filteredUserOrgStatus = statesUserOrg.filter((option) =>
  //   codeStatesEnabled.includes(option.userStatusCode),
  // )

  const getNameUser = () => {
    return userData.account?.firstName + " " + userData.account?.lastName
  }

  const handleOpenModalType = (value) => {
    setSelectedType(value)
    setisModalOpenTypeUser(true)
  }

  const handleOpenModalChangeStatus = (value, type) => {
    type === "login_account"
      ? setSelectedStatusLoginAccount(value)
      : setSelectedStatus(value)
    type === "login_account"
      ? setisModalOpenStatusAccount(true)
      : setisModalOpenStatusUserOrg(true)
  }

  const handleCloseModal = () => {
    setisModalOpenStatusUserOrg(false)
    setisModalOpenStatusAccount(false)
    setisModalOpenTypeUser(false)
    setIsModalOpenTypeComercialUserOrg(false)

  }

  const loadUserData = async () => {
    setLoading(true)
    const response = await dispatch(getDataUserOrganizationID(item.user_id))
    if (response !== "Error") {
      await getUserStatusLoginAccount(
        response.data.account.email,
        response.data,
      )
      await getUserStatus()
      await getAllTypes()
      await getUserOrgStatus()
      const typesC = await dispatch(getOrganizationCommercialUserType())
      setTypesComercial(typesC.data)
    }
    setLoading(false)
  }

  useEffect(() => {
    loadUserData()
  }, [])

  const userStatusConfig = {
    ACTIVE: {
      color: "green",
      icon: CheckCircleIcon,
      label: "Activo",
    },
    DELETED: {
      color: "red",
      icon: CancelIcon,
      label: "Dado de Baja",
    },
    WAITING_VALIDATION: {
      color: "blue",
      icon: HourglassTopOutlinedIcon,
      label: "Esperando Validación",
    },
  }

  const getStatusConfig = (statusCode) => {
    return (
      userStatusConfig[statusCode] || {
        color: "#aaa",
        icon: CheckCircleIcon,
        label: "Estado desconocido",
      }
    )
  }

  const StatusDisplay = ({ statusCode, statusName, disabled = false }) => {
    const config = getStatusConfig(statusCode)
    const IconComponent = config.icon
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {!disabled && (
          <IconComponent sx={{ color: config.color, fontSize: "20px" }} />
        )}
        <Typography sx={{ color: config.color }}>
          {statusName || config.label}
        </Typography>
      </Box>
    )
  }

  const DetailsUserOfSuscriber = () => {
    return (
      userData && (
        <>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                Nombre y apellido del usuario:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>{getNameUser()}</Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                Correo electrónico del usuario:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {userData.account?.email || "- -"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>Tipo de usuario:</Typography>
            </Grid>

            <Grid
              item
              xs={2}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <FormControl
                // variant="outlined"
                style={{ minWidth: 160 }}
                className={classes.value}
              >
                <Select
                  labelId="demo-simple-select-autowidth-label"
                  id="demo-simple-select-autowidth"
                  sx={{
                    height: 30,
                    border: "2px solid rgb(104, 106, 109)",
                    "& .MuiSelect-icon": {
                      color: "rgb(75, 77, 78)",
                    },
                    "&:hover": {
                      borderColor: "rgb(0, 167, 143)",
                    },
                  }}
                  value={currentUserTypeCode}
                  onChange={(e) => handleOpenModalType(e.target.value)}
                  renderValue={(selected) => {
                    if (!selected)
                      return <span style={{ color: "#aaa" }}>- -</span>
                    const selectedItem = typesUser.find(
                      (item) => item.organizationUserTypeCode === selected,
                    )
                    return (
                      getTraducTypeUser(
                        selectedItem?.organizationUserTypeCode,
                      ) || "- -"
                    )
                  }}
                >
                  {typesUser.map((item) => (
                    <MenuItem
                      key={item.organizationUserTypeId}
                      value={item.organizationUserTypeCode}
                      disabled={
                        !codeTypesEnabled.includes(
                          item.organizationUserTypeCode,
                        ) || !codeTypesEnabled.includes(currentUserTypeCode)
                      }
                    >
                      {getTraducTypeUser(item.organizationUserTypeCode)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <Typography className={classes.key}>
                Tipo comercial del usuario:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <FormControl style={{ minWidth: 160 }}
                className={classes.value}>
                <Select
                  labelId="demo-simple-select-autowidth-label"
                  id="demo-simple-select-autowidth"
                  sx={{
                    height: 30,
                    border: "2px solid rgb(104, 106, 109)",
                    "& .MuiSelect-icon": {
                      color: "rgb(75, 77, 78)",
                    },
                    "&:hover": {
                      borderColor: "rgb(0, 167, 143)",
                    },
                  }}
                  value={currentUserTypeComercialCode}
                  onChange={handleChangeTypeComercial}
                  renderValue={(selected) => {
                    if (!selected)
                      return <span style={{ color: "#aaa" }}>- -</span>
                    const selectedItem = typesComercial.find(
                      (item) => item.organizationCommercialUserTypeCode === selected,
                    )
                    return (

                      selectedItem?.organizationCommercialUserTypeName || ""
                    )
                  }}
                >
                  {typesComercial ? (
                    typesComercial.map((t) => (
                      <MenuItem
                        key={t.organizationCommercialUserTypeName}
                        value={t.organizationCommercialUserTypeCode}
                      >
                        {t.organizationCommercialUserTypeName}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem value="">
                      No se encontraron tipos comerciales
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                Usuario parte de la organización:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {userData.organization?.organizationName || "- -"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                CUIT de la organización:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {userData.organization?.organizationCuit || "- -"}
              </Typography>
            </Grid>
          </Grid>

          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                Estado del usuario organización:
              </Typography>
            </Grid>
            <Grid
              item
              xs={2}
              sx={{
                display: "flex",
                alignItems: "center",
                marginBottom: "5px",
              }}
            >
              <FormControl
                variant="outlined"
                style={{ minWidth: 160 }}
                className={classes.value}
              >
                <Select
                  labelId="demo-simple-select-autowidth-label"
                  id="demo-simple-select-autowidth"
                  sx={{
                    height: 30,
                    border: "2px solid rgb(104, 106, 109)",
                    "& .MuiSelect-icon": {
                      color: "rgb(75, 77, 78)",
                    },
                    "&:hover": {
                      borderColor: "rgb(0, 167, 143)",
                    },
                    display: "flex",
                    justifyContent: "center",
                  }}
                  value={currentUserOrgStatusCode}
                  onChange={(e) =>
                    handleOpenModalChangeStatus(e.target.value, "user_org")
                  }
                  renderValue={(selected) => {
                    if (!selected)
                      return <span style={{ color: "#aaa" }}>- -</span>
                    const selectedItem = statesUserOrg.find(
                      (item) => item.userStatusCode === selected,
                    )

                    if (!selectedItem) return ""
                    return (
                      <StatusDisplay
                        statusCode={selectedItem.userStatusCode}
                        statusName={selectedItem.userStatusName}
                      />
                    )
                  }}
                >
                  {statesUserOrg.map((item) => {
                    return (
                      <MenuItem
                        key={item.userStatusId}
                        value={item.userStatusCode}
                        disabled={
                          !codeStatesEnabled.includes(item.userStatusCode) ||
                          !codeStatesEnabled.includes(
                            userData?.status?.userStatusCode,
                          )
                        }
                      >
                        <StatusDisplay
                          statusCode={item.userStatusCode}
                          statusName={item.userStatusName}
                          disabled={
                            !codeStatesEnabled.includes(item.userStatusCode) ||
                            !codeStatesEnabled.includes(
                              userData?.status?.userStatusCode,
                            )
                          }
                        />
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                ID de usuario organización:
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.value}>
                {userData.userId || "- -"}
              </Typography>
            </Grid>
          </Grid>
          <Grid container className={classes.container}>
            <Grid
              item
              xs={5}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography className={classes.key}>
                Estado de cuenta de Login:
              </Typography>
            </Grid>
            <Grid
              item
              xs={2}
              sx={{
                display: "flex",
                alignItems: "center",
                marginBottom: "5px",
              }}
            >
              <FormControl
                variant="outlined"
                style={{ minWidth: 160 }}
                className={classes.value}
              >
                <Select
                  labelId="demo-simple-select-autowidth-label"
                  id="demo-simple-select-autowidth"
                  sx={{
                    height: 30,
                    border: "2px solid rgb(104, 106, 109)",
                    "& .MuiSelect-icon": {
                      color: "rgb(75, 77, 78)",
                    },
                    "&:hover": {
                      borderColor: "rgb(0, 167, 143)",
                    },
                  }}
                  value={currentUserStatusCode}
                  onChange={(e) =>
                    handleOpenModalChangeStatus(e.target.value, "login_account")
                  }
                >
                  {statesUser ? statesUser.map((item) => {
                    const isActive = item.accountStatusCode === "ACTIVE"
                    return (
                      <MenuItem
                        key={item.accountStatusId}
                        value={item.accountStatusCode}
                        disabled={
                          !(
                            item.accountStatusCode === "ACTIVE" &&
                            userData?.accountStatus?.accountStatusCode ===
                            "WAITING_VALIDATION"
                          )
                        }
                      >
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          {isActive && (
                            <CheckCircleIcon
                              sx={{ color: "green", fontSize: "20px" }}
                            />
                          )}
                          <Typography sx={isActive ? { color: "green" } : {}}>
                            {item.accountStatusDesc}
                          </Typography>
                        </Box>
                      </MenuItem>
                    )
                  }) : <MenuItem value="">
                    No se encontraron estados de cuenta
                  </MenuItem>}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          {isModalOpenTypeUser && (
            <ModalConfirmChange
              title={"Confirmar cambio de tipo de usuario-organización"}
              message={"¿Estás seguro de cambiar el tipo del usuario?"}
              onClose={handleCloseModal}
              onConfirm={handleChangeTypeUser}
            />
          )}

          {isModalOpenStatusUserOrg && (
            <ModalConfirmChange
              title="Confirmar cambio de estado"
              message={`¿Estás seguro de cambiar el estado del usuario-organización?`}
              onClose={handleCloseModal}
              onConfirm={handleChangeStatusUser}
            />
          )}
          {isModalOpenStatusAccount && (
            <ModalConfirmChange
              title="Confirmar cambio de estado"
              message={`¿Estás seguro de cambiar el estado del usuario?`}
              onClose={handleCloseModal}
              onConfirm={updateUserStatusLoginAcc}
            />
          )}
          {isModalOpenTypeComercialUserOrg && (
            <ModalConfirmChange
              title="Confirmar cambio de tipo comercial"
              message={`¿Estás seguro de cambiar el tipo comercial del usuario?`}
              onClose={handleCloseModal}
              onConfirm={handleChangeTypeComercialUser}
            />
          )}
        </>
      )
    )
  }
  function ButtonClose({ setstateSeeMore }) {
    const classes = useStyleUserSuscriberSeeMore()
    return (
      <Box className={classes.closeButton}>
        <Box
          className={classes.closeButtonStyle}
          sx={{
            "&:hover": {
              bgcolor: "#1BF57F",
            },
          }}
        >
          <Typography
            onClick={() => {
              setstateSeeMore(false)
            }}
            className={classes.closeButtonTypography}
          >
            Cerrar
          </Typography>
        </Box>
      </Box>
    )
  }

  return (
    <>
      <Box className={classes.backgroundBox}>
        <div
          style={{
            width: "100%",
            display: "flex",
            padding: "8px 0px 8px 0px",
            justifyContent: "space-between",
            boxShadow: "0px 1px 1px #EAEAEA",
            color: "#8C8C8C",
          }}
        >
          <Typography className={classes.seeMoreTypography}>
            Información del usuario
          </Typography>
          <CloseIcon
            style={{
              cursor: "pointer",
              paddingRight: 10,
              fontSize: "1.5rem",
            }}
            onClick={() => {
              setstateSeeMore(false)
            }}
          />
        </div>
        <div className={classes.mainBox}>
          <DetailsUserOfSuscriber />
        </div>
        <ButtonClose setstateSeeMore={setstateSeeMore} />
      </Box>
    </>
  )
}
